import React, { useEffect } from 'react';
import { BonadocsEditorViewActionsCode } from './BonadocsEditorViewActionsCode/BonadocsEditorViewActionsCode';
import { BonadocsEditorViewActionsSidebar } from './BonadocsEditorViewActionsSidebar/BonadocsEditorViewActionsSidebar';
import BonadocsEditorViewActionsOutput from './BonadocsEditorViewActionsOutput/BonadocsEditorViewActionsOutput';
import { getLatestBlock } from '@/utils/latestBlock';
import { CollectionDataManager, supportedChains } from '@bonadocs/core';
import { cacheBlockNumber, getCachedBlockNumber } from '@bonadocs/zimulatoor';
import { useCollectionContext } from '@/context/CollectionContext';
import { toast } from 'react-toastify';

export const BonadocsEditorViewActionsWrapper: React.FC = () => {
  const { getCollection } = useCollectionContext();
  useEffect(() => {
    updateBlockNumbers();
  }, []);

  async function getActiveNetworks(dataManager: CollectionDataManager) {
    let activeNetworks: Set<number> | undefined;
    const contractManager = await dataManager.getContractManagerView();
    for (const contract of contractManager.contracts) {
      const chainIds = contract.instances.map((instance) => instance.chainId);
      if (!activeNetworks) {
        activeNetworks = new Set(chainIds);
      } else {
        chainIds.forEach((chainId) => activeNetworks!.add(chainId));
      }
    }
    return activeNetworks!;
  }

  const updateBlockNumbers = async () => {
    try {

      const activeNetworks = await getActiveNetworks(getCollection()!);

      Array.from(activeNetworks).map(async (chainId) => {
        if (chainId) {
          let blockNumber = await getCachedBlockNumber(BigInt(chainId));

          if (!blockNumber) {
            const currentChain = Array.from(supportedChains).filter(
              (instance) => {
                if (Number(chainId) === instance[0]) {
                  return {
                    label: instance[1].name,
                    value: instance[1].chainId,
                  };
                }
              },
            );

            const rpcUrl = currentChain[0]?.[1].jsonRpcUrl;
            const chainIdBlock = await getLatestBlock(rpcUrl);

            await cacheBlockNumber(
              BigInt(chainId),
              BigInt(chainIdBlock),
              Date.now() + 3600000,
            );
          }
        }
      });
    } catch (error) {
      toast.error(`Error caching block number ${error}`, {
        toastId: 'error-listings',
      });
    }
  };

  return (
    <>
      <BonadocsEditorViewActionsSidebar />
      <BonadocsEditorViewActionsCode />
      <BonadocsEditorViewActionsOutput />
    </>
  );
};
